module.exports = __webpack_public_path__ + "img/promo-code-error-icon.ae7cb7df.svg";